import React, { useEffect, useState } from 'react';
import { Typography } from '@mui/material';

interface CountdownTimerProps {
  duration: number;
  storageKey: string;
  onExpire?: () => void;
}

const CountdownTimer: React.FC<CountdownTimerProps> = ({ duration, storageKey, onExpire }) => {
  const [timeLeft, setTimeLeft] = useState<number>(duration);

  useEffect(() => {
    const savedExpiry = localStorage.getItem(storageKey);
    let expiryTime: number;

    if (savedExpiry) {
      expiryTime = parseInt(savedExpiry, 10);
    } else {
      expiryTime = Date.now() + duration * 1000;
      localStorage.setItem(storageKey, expiryTime.toString());
    }

    const updateTimer = () => {
      const remaining = Math.max(0, Math.floor((expiryTime - Date.now()) / 1000));
      setTimeLeft(remaining);

      if (remaining === 0) {
        onExpire?.();
        localStorage.removeItem(storageKey);
      }
    };

    updateTimer(); // initial call
    const interval = setInterval(updateTimer, 1000);

    return () => clearInterval(interval);
  }, [duration, storageKey, onExpire]);

  const formatTime = (seconds: number) => {
    const m = Math.floor(seconds / 60).toString().padStart(2, '0');
    const s = (seconds % 60).toString().padStart(2, '0');
    return `${m}:${s}`;
  };

  return (
    <Typography
      sx={{
        fontSize: '24px',
        fontWeight: 'bold',
        color: timeLeft > 10 ? 'black' : '#D32F2F',
        mb: 1,
      }}
    >
      {formatTime(timeLeft)}
    </Typography>
  );
};

export default CountdownTimer;